import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterLookupGrievanceNotification',
    standalone: false
})
export class FilterLookupGrievanceNotificationPipe implements PipeTransform {

  transform(values: any[], idLookupTypeGrievanceNotification: number): any[] {
    return values.filter(x => x.idLookupTypeGrievanceNotification == idLookupTypeGrievanceNotification);
  }

}